const ActiveJobIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83685 0C5.22466 0 4.72839 0.496277 4.72839 1.10846V7.01932L0.300319 14.689C-0.552976 16.1669 0.513642 18.0144 2.22023 18.0144H12.7798C14.4864 18.0144 15.553 16.1669 14.6997 14.689L10.2707 7.01775V1.10846C10.2707 0.496276 9.77443 0 9.16224 0H5.83685Z"
        fill="#0AC4B2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.32422 0.831348C3.32422 0.372207 3.6078 0 3.95763 0H11.5585C11.9083 0 12.1919 0.372207 12.1919 0.831348C12.1919 1.29049 11.9083 1.6627 11.5585 1.6627H3.95763C3.6078 1.6627 3.32422 1.29049 3.32422 0.831348Z"
        fill="#0AC4B2"
      />
      <path
        d="M13.3574 15.0862L11.7665 11.5862C11.6042 11.2292 11.2482 11 10.8561 11H4.59363C4.22769 11 3.89097 11.1999 3.71574 11.5211L1.80665 15.0211C1.44317 15.6875 1.92548 16.5 2.68454 16.5H12.447C13.1743 16.5 13.6583 15.7483 13.3574 15.0862Z"
        fill="white"
        stroke="#0AC4B2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ActiveJobIcon;
